<template>
    <div>
        <el-menu
                class="sidebar-menu"
                background-color="rgb(48, 65, 86)"
                text-color="#fff"
                unique-opened
                :collapse="isCollapse"
                :router="true"
                :default-active="$route.path"
        >
            <template v-for="(submenu, index) in menu">
                <el-submenu
                        v-if="submenu.children && submenu.children.length > 0"
                        :index="index + ''"
                        :key="submenu.pid">
                    <template slot="title">
                        <i :class="submenu.powerIcon"></i>
                        <span slot="title">{{ submenu.powerName }}</span>
                    </template>
                    <span v-for="(item, index) in submenu.children">
                        <el-menu-item :key="index" v-if="item.newPage == 1">
                            <div @click.stop="goNewPage(item.authkey)" style="width: 100%">
                                <i :class="item.powerIcon"></i>
                                <span slot="title">{{ item.powerName }}</span>
                            </div>
                        </el-menu-item>
                        <el-menu-item :key="index" :index="item.authkey" v-else>
                            <i :class="item.powerIcon"></i>
                            <span slot="title">{{ item.powerName }}</span>
                        </el-menu-item>
                    </span>

                </el-submenu>
                <el-menu-item v-else :index="submenu.authkey" :key="submenu.pid">
                    <i :class="submenu.powerIcon"></i>
                    <span slot="title">{{ submenu.powerName }}</span>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
</template>

<script>
    export default {
        name: 'SideMenu',
        data() {
            return {
                isCollapse: false,
                foldBtnIcon: 'el-icon-back',
                menu: [],
            }
        },
        methods: {
            foldAdnExpand() {
                if (this.isCollapse) {
                    this.isCollapse = false
                    this.foldBtnIcon = 'el-icon-back'
                } else {
                    this.isCollapse = true
                    this.foldBtnIcon = 'el-icon-right'
                }

            },
            getMenu() {
                this.$post(this.$url.左侧菜单团队视图, {})
                    .then(resp => {
                        //获取最新权限信息
                        this.menu = resp
                    }).catch(() => {
                })

            },
            goNewPage(url) {
                console.log("111111")
                let routeData = this.$router.resolve({
                    path: url,
                });
                window.open(routeData.href, '_blank');
            }
        },
        mounted() {
            this.getMenu()
        }
    }
</script>

<style scoped lang="less">
    .sidebar-menu {
        //overflow-x: auto;
        border: none;
        height: 88vh;
        width: 100%;
        overflow-y: scroll;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */

        &::-webkit-scrollbar {
            display: none;
        }


    }

    .sidebar-menu:not(.el-menu--collapse) {
        width: 11vw;
    }

    .fold-btn {
        position: fixed;
        text-align: center;
        left: 13px;
        bottom: 13px;
    }
</style>
